var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelgram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_70)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_275_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V13.3333C0 14.8061 1.19391 16 2.66667 16H13.3333C14.8061 16 16 14.8061 16 13.3333V2.66667C16 1.19391 14.8061 0 13.3333 0Z",
    fill: "#34AADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90546 7.48401C3.90546 7.48401 8.03339 5.72787 9.46501 5.10949C10.0138 4.86215 11.8749 4.07062 11.8749 4.07062C11.8749 4.07062 12.734 3.72435 12.6623 4.56532C12.6385 4.91162 12.4476 6.12361 12.2567 7.43457C11.9704 9.28968 11.6602 11.318 11.6602 11.318C11.6602 11.318 11.6125 11.8869 11.2069 11.9857C10.8013 12.0847 10.1331 11.6395 10.0138 11.5405C9.9184 11.4664 8.22428 10.3533 7.60392 9.80913C7.43687 9.66071 7.24597 9.36388 7.62776 9.01761C8.4867 8.20133 9.51277 7.18727 10.1331 6.54417C10.4195 6.24734 10.7057 5.55472 9.51277 6.39566C7.81866 7.60775 6.14836 8.74554 6.14836 8.74554C6.14836 8.74554 5.76658 8.99285 5.05078 8.77022C4.33493 8.54769 3.4998 8.25085 3.4998 8.25085C3.4998 8.25085 2.92718 7.87982 3.90546 7.48401Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_275_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelgram);
export default __webpack_public_path__ + "static/media/telgram.e100e8d11e48ed7fb8c70c80ab908ca6.svg";
export { ForwardRef as ReactComponent };